import css from "./styles.module.scss";
import loading from "../../images/loading.gif";

export default function Loading({ overlay = false }) {
  return (
    <div className={css.container}>
      {overlay ? (
        <div className={css.overlay}>
          <img src={loading} alt="loading transport" />
        </div>
      ) : (
        <div className={css.containerLoading}>
          <img src={loading} alt="loading transport" />
        </div>
      )}
    </div>
  );
}
